module.exports = __webpack_public_path__ + "842a72851ec8b7911aff270b11843ef4.png";